import React from 'react';
import { STATE } from 'app/constants';
import { containerFactory } from 'app/infrastructure/redux';
import { SpinLoader } from 'app/components';

// HoC to use when a route requires all access information to be loaded before it can be rendered.
const withLoadedAccessInfo = (Component: React.ComponentType<any>) => {
  const accessInfoChecker = (props: Partial<{ fetchingAccessInfo: boolean }>) => {
    if (!props.fetchingAccessInfo) {
      return <Component {...props} />;
    }
    return <SpinLoader />;
  };

  accessInfoChecker.statePath = STATE.app;

  return accessInfoChecker;
};

export const withWaitForAccessInfo = (Component: React.ComponentType<any>) => containerFactory(withLoadedAccessInfo(Component));
